<template>
  <div id="app">
    <VinLookup />
  </div>
</template>

<script>
import VinLookup from './components/VinLookup.vue'

export default {
  name: 'App',
  components: {
    VinLookup
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
